import { Injectable } from '@angular/core';
import { CanActivate,  ActivatedRouteSnapshot} from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AccountInfo } from '@azure/msal-common';

interface Account extends AccountInfo {
  idTokenClaims?: {
    roles?: string[]
  }
}

@Injectable({
    providedIn: 'root'
  })
export class RoleGuardService implements CanActivate {

  constructor(private authService: MsalService) {}
  
  canActivate(route: ActivatedRouteSnapshot): boolean {
   debugger;
    
    if(route.data['expectedRole'] !== undefined)
    {

      console.log('custom debug code - from role-guardservice=' + route.data['expectedRole']);
    }
    const expectedRole = route.data['expectedRole'];
    
    console.log('custom debug code - call to get AllAccounts from role Guard service - custom code debug' );
    console.log('custom debug code - expectedrole = ' + expectedRole );
    
    let account: Account = this.authService.instance.getAllAccounts()[0];

    if(expectedRole !== null)
    {
      var expectedRolearray =  expectedRole.split(',');
      expectedRolearray.forEach((element: string) => {
        console.log("Expected Role = " + element);
      });
    }

    if (!account.idTokenClaims?.roles) {
      console.log('custom debug code -RoleGuardService - Token does not have roles claim. Please ensure that your account is assigned to an app role and then sign-out and sign-in again - custom debug code.')

      window.alert('Token does not have roles claim. Please ensure that your account is assigned to an app role and then sign-out and sign-in again.');
      return false;
    } 
    
    else if (!(account.idTokenClaims?.roles?.some(x=>expectedRolearray.includes(x)))) {


      console.log('custom debug code -RoleGuardService - You do not have access as expected role is missing. Please ensure that your account is assigned to an app role and then sign-out and sign-in again - custom debug code.')
      window.alert('You do not have access as expected role is missing. Please ensure that your account is assigned to an app role and then sign-out and sign-in again.');
      return false;
    }

    return true;
  }
}